import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import VideoDetail from "@/pages/VideoDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyVideos from "@/pages/MyVideos";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  useEffect(() => {
    document.title = "ART MONEY GROUP — Vidéos à la demande";
  }, []);

  return (
    <div className="App min-h-screen">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/video/:id" element={<VideoDetail />} />
            <Route path="/connexion" element={<Login />} />
            <Route path="/inscription" element={<Register />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
            <Route path="/mes-videos" element={<MyVideos />} />
            <Route path="/paiement/success" element={<PaymentSuccess />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
